import { render } from "./ResetPasswordBySystemAdminPage.vue?vue&type=template&id=7a5c62ce&ts=true"
import script from "./ResetPasswordBySystemAdminPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordBySystemAdminPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__